import ProjectsInner from './ProjectsInner';

export default ProjectsInner;
